/**
 * Utilidades para procesamiento de datos
 */

/**
 * Convierte tiempo en formato HH:MM:SS a minutos
 * @param {string} timeStr - String de tiempo en formato HH:MM:SS
 * @returns {number} Tiempo en minutos
 */
export function convertToMinutes(timeStr) {
  const [hours, minutes, seconds] = timeStr.split(":").map(Number);
  return hours * 60 + minutes + seconds / 60;
}

/**
 * Obtiene array de información de datos actualizada
 * @param {Object} newInfo - Información nueva
 * @returns {Object} Información de datos procesada
 */
export function getArrayInfoDataUpdate(newInfo) {
  const URLimagen =
    "https://catalog.facetbarcelona.com/images/database-odoo/FM/";
  const {
    referencia,
    descripcion,
    po,
    mo,
    fechaentrega,
    observaciones,
    stamping,
    sureferencia,
    cantidad,
    imagen,
    instrucciones,
    clasificacioncliente,
    cantidad_terminada,
    cantidad_fabricada,
    siguientePaso,
    imagen_stamping,
    tipo_orden,
    tiempos,
    recepcion,
    piedras,
    fornitura,
    eFabrica,
    tFabrica,
    pesobruto,
    imgcalidad,
    documentacion,
  } = newInfo;

  const infoData = {
    referencia,
    descripcion,
    PO: po,
    MO: mo,
    fechaEntrega: fechaentrega,
    observaciones,
    stamping,
    sureferencia,
    cantidad,
    image: imagen ? URLimagen + imagen : "",
    imagen_stamping: imagen_stamping ? URLimagen + imagen_stamping : "",
    imgcalidad: imgcalidad ? URLimagen + imgcalidad : "",
    tipo_orden: tipo_orden ? tipo_orden : "",
    instrucciones: instrucciones ? instrucciones : "",
    clasificacionCliente: clasificacioncliente ? clasificacioncliente : "",
    cantidad_fabricada: cantidad_fabricada ? cantidad_fabricada : "",
    cantidad_terminada: cantidad_terminada ? cantidad_terminada : "",
    siguientePaso: siguientePaso ? siguientePaso : " -- ",
    tiempos: tFabrica ? tFabrica : "", // Dejarlo vacío por ahora para asignarlo posteriormente
    recepcion: recepcion ? recepcion : "",
    piedras: piedras ? piedras : "",
    fornitura: fornitura ? fornitura : "",
    eFabrica,
    pesobruto: pesobruto ? pesobruto : "",
    documentacion: documentacion ? documentacion : "",
  };

  return infoData;
}

/**
 * Convierte duración en formato HH:MM:SS a minutos
 * @param {string} durationStr - String de duración en formato HH:MM:SS
 * @returns {number|null} Duración en minutos o null si es inválida
 */
export const parseDurationToMinutes = (durationStr) => {
  if (!durationStr || typeof durationStr !== "string") return null;
  const parts = durationStr.split(":");
  if (parts.length !== 3) return null;
  const [hoursStr, minutesStr, secondsStr] = parts;
  const hours = parseInt(hoursStr, 10);
  const minutes = parseInt(minutesStr, 10);
  const seconds = parseInt(secondsStr, 10);
  if (isNaN(hours) || isNaN(minutes) || isNaN(seconds)) return null;
  const totalMinutes = hours * 60 + minutes + seconds / 60;
  return totalMinutes;
};

/**
 * Extrae minutos de una duración
 * @param {any} duracion - Duración en cualquier formato
 * @returns {number} Minutos extraídos
 */
export function extraerMinutos(duracion) {
  if (duracion === undefined || duracion === null) return 0;
  if (typeof duracion === "number") {
    return isNaN(duracion) ? 0 : duracion;
  }

  if (typeof duracion === "object" && duracion?.date) duracion = duracion.date;

  if (typeof duracion === "string") {
    if (!duracion.trim() || duracion.toLowerCase().includes("nan")) return 0;

    let horaStr = duracion;
    if (horaStr.includes(" ")) {
      horaStr = horaStr.split(" ")[1];
    }
    const partes = horaStr.split(":");
    if (partes.length >= 2) {
      const horas = parseInt(partes[0], 10);
      const minutos = parseInt(partes[1], 10);
      if (!isNaN(horas) && !isNaN(minutos)) {
        return horas * 60 + minutos;
      }
    }

    const min = parseInt(duracion, 10);
    if (!isNaN(min)) return min;
  }
  console.warn("Dato de duración inesperado:", duracion);
  return 0;
}

/**
 * Obtiene el precio total por rango de clientes
 * @param {Array} response - Array de MOs
 * @param {string} clienteSeleccionado - Cliente seleccionado
 * @returns {number} Precio total redondeado
 */
export function getPrecioTotalPorRango(response, clienteSeleccionado) {
  let precioTotal = 0;

  console.log("🔍 Total MOs recibidas:", response.length);

  const mosFiltradas = response.filter((mo) => {
    const clienteCoincide =
      !clienteSeleccionado ||
      clienteSeleccionado === "" ||
      mo.cliente === clienteSeleccionado;
    return clienteCoincide;
  });

  let mosConProcesos = 0;
  let mosConPrecio = 0;
  let totalProcesos = 0;

  mosFiltradas.forEach((mo, index) => {
    let precioMO = 0;

    if (mo.procesos && mo.procesos.length > 0) {
      mosConProcesos++;
      totalProcesos += mo.procesos.length;

      mo.procesos.forEach((proceso) => {
        const tiempo = parseFloat(proceso.tiempo || 0);
        const precio = parseFloat(proceso.precio || 0);
        const cantidad = parseFloat(mo.cantidad || 0);
        const costoProceso = tiempo * precio * cantidad;

        precioMO += costoProceso;
      });

      if (precioMO > 0) {
        mosConPrecio++;
      }
    }

    precioTotal += precioMO;
  });

  return Math.round(precioTotal * 100) / 100;
}

/**
 * Formatea un número eliminando decimales innecesarios
 * @param {any} value - Valor a formatear
 * @returns {string} Número formateado como string
 */
export function formatNumber(value) {
  if (value === null || value === undefined) return '';
  
  if (typeof value === 'number' || (typeof value === 'string' && !isNaN(value))) {
    const numValue = parseFloat(value);
    if (numValue % 1 === 0) {
      return String(Math.round(numValue));
    }
    return numValue.toString();
  }
  
  return String(value);
}

/**
 * Limpia el nombre de usuario eliminando prefijos
 * @param {string} userName - Nombre de usuario completo
 * @returns {string} Nombre limpio
 */
export function cleanUserName(userName) {
  if (!userName) return '';
  return userName.split('-').pop() || userName;
}

/**
 * Formatea las piedras de una MO para mostrar en modales
 * @param {Object} moData - Datos de la MO
 * @param {Object} precios - Objeto con precios unitarios
 * @returns {Array} Array de piedras formateadas
 */
export function formatPiedrasForModal(moData, precios) {
  if (!moData.tiemposProceso?.PIEDRAS) return [];
  
  return Object.entries(moData.tiemposProceso.PIEDRAS).map(([codigo, cantidad]) => ({
    codigo,
    cantidad: parseInt(cantidad) || 0,
    precioUnitario: precios.PIEDRA_UNITARIO,
    precioTotal: (parseInt(cantidad) || 0) * precios.PIEDRA_UNITARIO
  }));
}

/**
 * Convierte un valor a string de forma segura
 * @param {any} value - Valor a convertir
 * @returns {string} String seguro
 */
export function safeString(value) {
  if (value === null || value === undefined) return '';
  if (typeof value === 'object' && value.date) {
    // Si es un objeto con fecha, usar la fecha
    return value.date;
  }
  return String(value);
}